


























































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import {  SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { Prop } from 'vue-property-decorator';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { DropdownLight } from '@/shared/dropdown-light';
import { SwTabGroup, SwTabPage, TabProps } from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
import { NoficationPref, EmailSubscr } from '../types';

const cssPrefix = 'alert-setting';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    DropdownLight,
    SwTabGroup,
    SwTabPage,
    SwToggle,
  },
})
export default class AlertSetting extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ required : true })
  alertSettingsModal: boolean;

  @Prop({ required : true })
  notificationPreferences : any;

  @Prop({ required: true })
  emailSubscriptionList : any;

  selectedTabId: string = 'tab1';
  notificationPrefModified: Array<NoficationPref> = []; // tslint:disable-line
  tempNotificationPrefMod: any = [];
  emailSubscriptions : Array<EmailSubscr> = []; // tslint:disable-line
  basicTabsProps: TabProps[] = [
    {
      tabId: 'tab1',
      label: this.$t('profile.notifications')
      .toString(),
    },
    {
      tabId: 'tab2',
      label: this.$t('profile.emailSubscriptions')
      .toString(),
    },
  ];

  onSelectTab(tabId: string) {
    this.selectedTabId = tabId;
  }

  mounted() {
    console.warn(this.notificationPreferences);
    this.notificationPrefModified = this.notificationPreferences.map((notification:any) => {
      return {
        notificationPrefText: notification.notificationPrefText,
        inapp: notification.notificationPrefChoiceId === '2' || notification.notificationPrefChoiceId === '1' ? true : false,
        emailInApp: notification.notificationPrefChoiceId === '2' ? true : false,
        notificationTypeID: notification.notificationTypeID,
      };
    });
    console.warn(this.notificationPrefModified);
    this.tempNotificationPrefMod = this.notificationPrefModified;
    this.emailSubscriptions = this.emailSubscriptionList;
  }

  onInAppPrefChange(noti: any) {
    this.notificationPrefModified = this.tempNotificationPrefMod.map((notify: any) => {
      if (notify.notificationTypeID === noti.notificationTypeID) {
        if (noti.inapp === false) {
          notify.inapp = false;
          notify.emailInApp = false;
        } else {
          notify.inapp = true;
        }
        return notify;
      } else { // tslint:disable-line
        return notify;
      }
    });
  }

  onEmailInAppPrefChange(noti: any) {
    this.notificationPrefModified = this.tempNotificationPrefMod.map((notify: any) => {
      if (notify.notificationTypeID === noti.notificationTypeID) {
        if (noti.emailInApp === false) {
          notify.inapp = false;
          notify.emailInApp = false;
        } else {
          notify.emailInApp = true;
          notify.inapp = true;
        }
        return notify;
      } else { // tslint:disable-line
        return notify;
      }
    });
  }

  closeDialog(refreshRequired:boolean = false) {
    this.$emit('close-modal', refreshRequired);
  }

  submit() {
    if (this.selectedTabId === 'tab1') {
      const modifiedNotiPref = this.notificationPreferences;
      this.notificationPrefModified.forEach((element: any, index: any) => {
        if (element.emailInApp) {
          modifiedNotiPref[index].notificationPrefChoiceId = '2';
        } else if (element.inapp) {
          modifiedNotiPref[index].notificationPrefChoiceId = '1';
        } else {
          modifiedNotiPref[index].notificationPrefChoiceId = '0';
        }
      });
      const request = {
        notificationpref: modifiedNotiPref,
      };
      console.warn(request);
      // const request = {
      //   notificationpref : req,
      // };
      this.$store.dispatch('SnbProfileStoreModule/updateNotificationPrefs', request)
        .then((resp) => {
          if (resp.operationStatus === 'OK') {
            // this.notificationPreferences = req;
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            this.closeDialog(true);
          } else {
            // this.closeDialog(false)
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          }
        })
        .catch((err:any) => {
          console.error(err);
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        });
    } else {
      const request = {
        EmailSubscriptionList : this.emailSubscriptions,
      };
      this.$store.dispatch('SnbProfileStoreModule/updateEmailPreference', request)
      .then((resp) => {
        if (resp.operationStatus === 'OK') {
          this.closeDialog(true);
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: this.$t('common.success')
          .toString() });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: this.$t('multiactivationstatus.failed')
          .toString() });
        }
      })
      .catch((err:any) => {
        console.error(err);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
    }
  }
}
